module.exports = __webpack_public_path__ + "img/20211002.1a515f45.gif";